export function mergePdf() {
  displayMergeFrameEvents();
  displayMoreAttachmentsEvent();
}

function displayMergeFrameEvents() {
  const frameSelector = [
    '.program-print-merge-frame',
    '.program-print-merge-frame-pointer',
  ].join(',');

  $('.program-print-merge').on('click', function () {
    $(frameSelector).toggleClass('hidden');
  });

  $('.program-print-merge-frame-close').on('click', function () {
    $(frameSelector, window.parent.document).addClass('hidden');
  });

  $(document).on('mousedown', function (e) {
    const $frame = $(frameSelector);
    if (
      !$frame.is(e.target) &&
      $frame.has(e.target).length === 0 &&
      !$frame.hasClass('hidden')
    ) {
      $frame.addClass('hidden');
    }
  });
}

function displayMoreAttachmentsEvent() {
  $('.program-print-merge-more').on('click', function () {
    $('.app-print-merge-attachment.hidden').slice(0, 5).removeClass('hidden');

    if ($('.app-print-merge-attachment.hidden').length === 0) {
      $(this).addClass('hidden');
    }
  });
}
